'use strict';

import Component from 'generic.basecomponent';
import scroller from 'scroller';

export default class MoveTo extends Component {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        this.triggers = document.querySelectorAll('.js-move-to-trigger');
        this.moveToBlock = document.querySelector('.js-move-to-block');
        this.triggers.forEach(x => x.addEventListener('click', this.moveTo.bind(this)));
    }

    moveTo() {
        return scroller.scrollToElement(this.moveToBlock);
    }
}

MoveTo.id = 0;



// WEBPACK FOOTER //
// ./app/components/move-to/js/generic.move-to.js